import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  Drawer,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const PaymentNav = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  // Sidebar open/close state
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Function to toggle sidebar
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Handle navigation to Home
  const handleHomeClick = () => {
    navigate("/"); // Navigate to home page
  };

  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: theme.palette.primary.main,
          boxShadow: "none",
          paddingTop: "15px",
        }}
      >
        <Toolbar
          sx={{
            justifyContent: { md: "space-between", xs: "space-between" },
            px: { xs: 2, md: 2 },
            py: { xs: 2, md: 2 },
            position: "relative", // Important to position children inside the toolbar
          }}
        >
          {/* Logo and Hamburger Icon in one div */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "30%",
              marginLeft: { xs: 0, md: "1vw" },
            }}
          >
            {/* Hamburger Icon (visible only on small screens) */}
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleSidebar} // Toggle sidebar on click
              sx={{
                // display: { xs: "block", md: "block" },
                display:'none',
                marginLeft: { xs: 0, md: 0 },
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="40px"
                viewBox="0 0 24 24"
                width="40px"
                fill="#FFFFFF"
              >
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path d="M4 18h16v-2H4v2zm0-5h16v-2H4v2zm0-7v2h16V6H4z" />
              </svg>
            </IconButton>

            {/* Brand Name (Drips Water) */}
            <Typography
              variant="h6"
              component="div"
              sx={{
                color: "#FFFFFF",
                fontSize: { xs: "1.4rem", md: "1.8rem" },
                fontFamily: "Poppins, sans-serif",
                fontWeight: "bold",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                width: { xs: "80%", md: "auto" },
              }}
            >
              Drips Water
            </Typography>
          </Box>

          {/* Home button */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "left",
              width: "20%",
            }}
          >
            <Button
              color="inherit"
              sx={{
                color: "#FFFFFF",
                ml: 2,
                textTransform: "capitalize",
                fontSize: "1.1rem",
                // backgroundColor:'#114C78',
                padding:'10px',
                borderRadius:'10px',
              }}
              onClick={handleHomeClick} // Navigate to Home
            >
              Home
            </Button>
          </Box>

          {/* Top-right corner SVG */}
          <Box
            sx={{
              position: "absolute",
              top: -20, // Adjust as needed to fine-tune positioning
              right: 0,
              zIndex: 2, // Ensures it stays behind other elements
            }}
          >
            <svg
              width="226"
              height="218"
              viewBox="0 0 226 218"
              fill="#C7E7FF"
              xmlns="http://www.w3.org/2000/svg"
            >
              <ellipse
                cx="236.5"
                cy="16.5"
                rx="236.5"
                ry="201.5"
                fill="#C7E7FF"
              />
            </svg>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default PaymentNav;
